import { memo } from 'react';
import { Hotspot } from './Hotspot.js';
import { Image } from './Image.js';
import { Input } from './Input.js';
import { LegacyCanvasDrawing } from './LegacyCanvasDrawing.js';
import { LegacyCanvasShape } from './LegacyCanvasShape.js';
import { Line } from './Line.js';
import { Shape } from './Shape.js';
import { Table } from './Table.js';
import { Text } from './Text.js';
import { jsx, Fragment } from 'react/jsx-runtime';

const RenderComponentUnmemoized = ({
  item,
  ...props
}) => {
  switch (item.kind) {
    case "text":
      return /*#__PURE__*/jsx(Text, {
        item: item,
        ...props
      });
    case "input":
      return /*#__PURE__*/jsx(Input, {
        item: item,
        ...props
      });
    case "shape":
      return /*#__PURE__*/jsx(Shape, {
        item: item,
        ...props
      });
    case "legacyCanvasShape":
      return /*#__PURE__*/jsx(LegacyCanvasShape, {
        item: item,
        ...props
      });
    case "legacyCanvasDrawing":
      return /*#__PURE__*/jsx(LegacyCanvasDrawing, {
        item: item,
        ...props
      });
    case "image":
      return /*#__PURE__*/jsx(Image, {
        item: item,
        ...props
      });
    case "table":
      return /*#__PURE__*/jsx(Table, {
        item: item,
        ...props
      });
    case "linkHotspot":
    case "speechHotspot":
      return /*#__PURE__*/jsx(Hotspot, {
        item: item,
        ...props
      });
    case "line":
      return /*#__PURE__*/jsx(Line, {
        item: item,
        ...props
      });
    default:
      return /*#__PURE__*/jsx(Fragment, {});
  }
};
const RenderComponent = /*#__PURE__*/memo(RenderComponentUnmemoized);

export { RenderComponent };
//# sourceMappingURL=RenderComponent.js.map
